import css from './trashButton.module.css'
import TrashIcon from '../../../assets/icons/trash.svg?react'
import { CSSProperties, MouseEvent } from 'react'

interface IProps {
  onClick: (ev: MouseEvent<HTMLDivElement>) => void
  style?: CSSProperties
  iconStyle?: CSSProperties
}

const TrashButton = (props: IProps) => {
  return (
    <div className={css.wrapper} onClick={props.onClick} style={props.style}>
      <TrashIcon className={css.icon} style={props.iconStyle} />
    </div>
  )
}

export default TrashButton
